import React from "react";
import { IStack } from "../types";

export const StacksContext = React.createContext<IStack[]>([]);
